import { css } from 'linaria';
import { styled } from 'linaria/react';
import { breakpoints } from 'common/styles/breakpoints';

export const vacanciesLink = css`
  display: block;
`;

export const storeVacanciesText = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: var(--space-300) 0;
  ${breakpoints.from.tablet} {
    margin: var(--space-400) 0;
  }
`;

export const WorkText = styled.div`
  display: flex;
  flex-direction: row;
`;

export const iconAlign = css`
  margin-left: var(--space-50);
  vertical-align: top;
`;

export const idIconAlign = css`
  margin-right: var(--space-200);
  vertical-align: top;
`;
export const divider = css`
  position: absolute;
  left: calc(-50vw + 50%);
  width: 100vw !important;
  margin: 0;

  ${breakpoints.only.mobile} {
    left: var(--space-200);
    right: var(--space-200);
    width: auto;
    max-width: calc(100% - var(--space-400)) !important;
  }
`;

export const storeVacanciesContainer = css`
  ${breakpoints.from.desktop} {
    grid-area: 4 / 1 / 5 / 3;
  }
`;
